module.exports = __webpack_public_path__ + "static/media/returnx.06aef951.svg";